var map = {
	"./blog.yml": 141,
	"./cloud.yml": 142,
	"./color.yml": 143,
	"./country.yml": 144,
	"./dio.yml": 145,
	"./doc.yml": 146,
	"./emoji.yml": 147,
	"./flag.yml": 148,
	"./git.yml": 149,
	"./icon.yml": 150,
	"./license.yml": 151,
	"./link.yml": 152,
	"./metrics.yml": 153,
	"./people.yml": 154,
	"./soft.yml": 155,
	"./src.yml": 156,
	"./status.yml": 157,
	"./taxonomy.yml": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;